/**
 * FAQ – einmal gepflegt, zweimal ausgespielt: sichtbar auf der Seite
 * und als JSON-LD im <head>. So können die beiden nicht auseinanderlaufen.
 *
 * Die Fragen sind keine Erfindung, sondern echte Suchanfragen aus der
 * Search Console (Cluster "kosten", "rentabel", "mieten", "aufstellen").
 */
export interface FaqEntry {
  question: string;
  answer: string;
}

export const FAQ_ENTRIES: FaqEntry[] = [
  {
    question: $localize`:@@rechnerFaq.q1:Was kostet ein Verkaufsautomat?`,
    answer: $localize`:@@rechnerFaq.a1:Eine marktbox kostet 6.800 € netto im Kauf oder 300 € netto pro Monat in der Miete bei 12 Monaten Laufzeit. Enthalten sind 39 Fächer, bargeldlose Bezahlung, Mobilfunkanbindung und die WebApp zur Steuerung.`,
  },
  {
    question: $localize`:@@rechnerFaq.q2:Was kostet es, einen Verkaufsautomaten aufzustellen?`,
    answer: $localize`:@@rechnerFaq.a2:Das Aufstellen selbst verursacht bei einer marktbox kaum Kosten: Sie braucht einen festen, ebenen Untergrund und eine normale Steckdose. Auf dem eigenen Grundstück fallen keine zusätzlichen Kosten an. Auf fremder Fläche kommt eine Stellplatzmiete hinzu, im öffentlichen Raum je nach Bundesland auch eine Genehmigung.`,
  },
  {
    question: $localize`:@@rechnerFaq.q3:Wie hoch sind die laufenden Kosten eines Automaten?`,
    answer: $localize`:@@rechnerFaq.a3:Rund 56 € an Fixkosten pro Monat: 19,71 € Strom (60 Watt Dauerbetrieb bei 0,45 €/kWh), 16,67 € Versicherung und 20 € Mobilfunk. Dazu 10 Cent pro Transaktion – im Durchschnittsfall etwa 36 €. Zusammen rund 92 € im Monat.`,
  },
  {
    question: $localize`:@@rechnerFaq.q4:Wie viel Umsatz macht ein Verkaufsautomat im Monat?`,
    answer: $localize`:@@rechnerFaq.a4:Über die ersten 450 marktbox-Automaten liegt der Durchschnitt bei 2.076 € netto pro Monat. Schwache Standorte kommen auf rund 600 €, starke auf bis zu 4.800 €. Der Standort ist der mit Abstand größte Hebel.`,
  },
  {
    question: $localize`:@@rechnerFaq.q5:Wie rentabel sind Verkaufsautomaten?`,
    answer: $localize`:@@rechnerFaq.a5:Im Durchschnittsfall bleiben nach Wareneinsatz und laufenden Kosten rund 904 € pro Monat übrig. Bei 6.800 € Anschaffung ist der Automat nach etwa 7,5 Monaten bezahlt. Bei zugekaufter Ware mit 30 % Marge rund 13 Monate.`,
  },
  {
    question: $localize`:@@rechnerFaq.q6:Ab wann ist eine Amortisation gut?`,
    answer: $localize`:@@rechnerFaq.a6:Ein brauchbarer Maßstab ist die steuerliche Abschreibungsdauer: Der Fiskus setzt für Verkaufsautomaten 60 Monate an. Alles, was deutlich darunter liegt, ist wirtschaftlich ein guter Fall. Im Durchschnitt liegt eine marktbox bei 7,5 Monaten.`,
  },
  {
    question: $localize`:@@rechnerFaq.q7:Lohnt es sich eher, einen Verkaufsautomaten zu kaufen oder zu mieten?`,
    answer: $localize`:@@rechnerFaq.a7:6.800 € Kaufpreis geteilt durch 300 € Monatsmiete ergeben knapp 23 Monate. Bis dahin ist Miete günstiger, danach der Kauf – unabhängig vom Umsatz. Miete eignet sich, wenn der Standort noch nicht erprobt ist.`,
  },
  {
    question: $localize`:@@rechnerFaq.q8:Lohnt sich ein zweiter Automat am selben Standort?`,
    answer: $localize`:@@rechnerFaq.a8:Ein marktbox-Automat hat 39 Fächer. Reicht das nicht, stellt man einen zweiten daneben. Der rechnet sich etwas besser als der erste, weil Versicherung und Mobilfunk je Standort anfallen und nicht je Automat. Rund jeder fünfte marktbox-Kunde rüstet nach.`,
  },
  {
    question: $localize`:@@rechnerFaq.q9:Wie viel Arbeit macht ein Verkaufsautomat?`,
    answer: $localize`:@@rechnerFaq.a9:Eine komplette Befüllung dauert im Schnitt 2 bis 6 Minuten. Dazu kommt der Fahrtweg, falls der Automat nicht direkt am Betrieb steht. Bestände und Verkäufe sehen Sie jederzeit in der WebApp.`,
  },
  {
    question: $localize`:@@rechnerFaq.q10:Gibt es Fördermittel für Verkaufsautomaten?`,
    answer: $localize`:@@rechnerFaq.a10:Ja. Für Direktvermarkter und landwirtschaftliche Betriebe existieren Förderprogramme, die einen Teil der Anschaffung übernehmen können.`,
  },
];

export function buildFaqJsonLd(entries: FaqEntry[]): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: entries.map((entry) => ({
      '@type': 'Question',
      name: entry.question,
      acceptedAnswer: { '@type': 'Answer', text: entry.answer },
    })),
  };
}
